import ledImg from "@/assets/cc_img4_baseball.png";

const stats: Array<[string, string]> = [
  ["1st", "of its kind"],
  ["8K", "LED environments"],
  ["7.1", "spatial stadium audio"],
  ["4K", "cinematic capture"],
  ["$10M", "flagship raise"],
  ["∞", "franchise scalable"],
];

export function WhatIs() {
  return (
    <section id="what-is" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img src={ledImg} alt="" aria-hidden width={1920} height={1080} loading="lazy" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/60 to-background" />
      </div>
      <div className="relative mx-auto max-w-6xl px-6 grid md:grid-cols-12 gap-12 items-start">
        <div className="md:col-span-5">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">What Is ClutchCube</p>
          <h2 className="font-display text-4xl sm:text-5xl leading-tight">
            They don't watch the game. <span className="text-gradient-ember">They step into it.</span>
          </h2>
        </div>
        <div className="md:col-span-7 space-y-6 text-lg text-muted-foreground leading-relaxed">
          <p>
            ClutchCube is a physical immersive sports entertainment venue built around
            high-resolution seamless LED simulation rooms. Each room recreates iconic sports
            environments from around the world and gives fans the chance to perform under
            pressure, compete with others, capture the moment, and leave with a cinematic
            memory they can share.
          </p>
          <p>
            Designed for ticket sales, group experiences, corporate events, birthdays, fan
            activations, team partnerships, memberships, leagues, sponsorships, and future
            franchise expansion — ClutchCube is built as both a consumer experience and a
            scalable venue platform.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 pt-6 border-t border-border">
            {stats.map(([k, v]) => (
              <div key={v}>
                <div className="font-display text-3xl text-primary">{k}</div>
                <div className="text-xs uppercase tracking-widest text-muted-foreground mt-1">{v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
